<style src="./Dashboard.scss" lang="scss"></style>
<template>
  <section class="dashboard no-margin">
    <section class="wrapper wrapper-content animated fadeIn">
      <div class="row">
        <div class="col-lg-3">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <span class="label label-success pull-right">Mensal</span>
              <h5>{{ currentMonth }}</h5>
            </div>
            <div class="ibox-content headerslot">
              <div class="row">
                <div class="col-sm-6">
                  <h2 class="no-margins">
                    <small class="smallCurrency">R$</small>
                    {{ monthTotal | totalToCurrencyBR | removeDecimal
                    }}<small>{{
                      monthTotal | totalToCurrencyBR | getDecimal
                    }}</small>
                  </h2>
                  <small>Venda Cliente</small>
                </div>
                <!-- <div class="col-sm-6" v-if="hasWalletPermission">
                  <h2
                    class="no-margins"
                    :title="
                      `Cartão: R$${monthWallet.card} - Pix: R${monthWallet.pix}`
                    "
                  >
                    <small class="smallCurrency">R$</small>
                    {{ monthWalletTotal | totalToCurrencyBR | removeDecimal
                    }}<small>{{
                      monthWalletTotal | totalToCurrencyBR | getDecimal
                    }}</small>
                  </h2>
                  <small>Compra Carteira</small>
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <span class="label label-success pull-right">Hoje</span>
              <h5>Receita Atual</h5>
            </div>
            <div class="ibox-content headerslot">
              <h1 class="no-margins">
                <small>R$</small>
                {{ todayTotal | totalToCurrencyBR | removeDecimal }}
                <small>{{ todayTotal | totalToCurrencyBR | getDecimal }}</small>
              </h1>
              <small>Em Pagamentos efetuados</small>
            </div>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <span class="label label-primary pull-right">Vagas</span>
              <h5>Estacionamento</h5>
            </div>
            <div class="ibox-content headerslot">
              <div class="row">
                <div class="col-sm-4">
                  <h1 class="no-margins">{{ totalParkingAvailable }}</h1>
                  <small>Disponíveis</small>
                </div>

                <div class="col-sm-4">
                  <h1 class="no-margins">{{ totalParkingOccuped }}</h1>
                  <small>Em uso</small>
                </div>
                <div
                  class="col-sm-4"
                  :class="{
                    'text-navy': totalOccupancyRate > 50,
                    'text-danger': totalOccupancyRate <= 50,
                  }"
                >
                  <h1 class="no-margins">{{ totalOccupancyRate }}%</h1>
                  <small class="text-muted">Taxa</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <span class="label label-danger pull-right">Irreg</span>
              <h5>Irregularidades / Isento</h5>
            </div>
            <div class="ibox-content headerslot">
              <div class="row">
                <div class="col-sm-6">
                  <h2 class="no-margins">
                    <small>R$</small>
                    {{ notifyAmountTotal | totalToCurrencyBR | removeDecimal }}
                    <small>{{
                      notifyAmountTotal | totalToCurrencyBR | getDecimal
                    }}</small>
                  </h2>
                  <small
                    ><strong>{{ notifyCount }}</strong> negativos</small
                  >
                  <small class="smallperc"> {{ percentualNotify }}% </small>
                </div>
                <div
                  @mouseover="hover = true"
                  @mouseleave="hover = false"
                  class="col-sm-6"
                >
                  <h2 class="no-margins">
                    <small>total: </small>{{ agedCount }}

                    <table
                      v-if="hover"
                      class="table table-hover table-mail hover-content"
                    >
                      <thead class="table-head">
                        <tr>
                          <th><small>Plano</small></th>
                          <th><small>%</small></th>
                        </tr>
                      </thead>
                      <tbody class="table-list">
                        <tr
                          v-for="(item, itemKey) in exceptions"
                          :key="itemKey"
                        >
                          <td class="list-command">
                            <small>{{ item.name }}</small>
                          </td>
                          <td class="list-command">
                            <small>{{ item.percent }}</small>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <parking-sheet
            :parking-use="parkingUse"
            :periods="parkingUseFilter"
          />
        </div>
        <!-- <div class="col-lg-4"> -->
        <!-- <notify-ranking :notify-ranking="notifyRanking" /> -->
        <!-- </div> -->
      </div>
    </section>
  </section>
</template>

<script>
import ParkingSheet from './components/parking-sheet/ParkingSheet';
// import NotifyRanking from './components/notify-ranking/NotifyRanking'
import moment from 'moment';

let intervalRefresh = null;

export default {
  name: 'Dashboard',
  components: {
    ParkingSheet,
    // NotifyRanking
  },
  data() {
    return {
      hover: false,
      monthReport: [],
      monthWallet: {
        card: 0,
        pix: 0,
      },
      parkingUseFilter: {
        firstPeriodStart: '03',
        firstPeriodEnd: '13',
        secondPeriodStart: '13',
        secondPeriodEnd: '22',
      },
      parkingUse: {
        parkStats: [],
        firstPeriodTotal: 0,
        secondPeriodTotal: 0,
        totalPeriods: 0,
      },
      notifyRanking: [],
      notifyCount: 0,
      notifyAmountTotal: 0,
      agedCount: 0,
      agedAmountTotal: 0,
      exceptions: [],
      currentMonth: '',
      lastDateRefresh: '',
    };
  },
  filters: {
    totalToCurrencyBR(value) {
      if (!value) {
        return '0,00';
      }
      return value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    getDecimal(value) {
      return value.substr(value.indexOf(','), 3);
    },
    removeDecimal(value) {
      return value.substr(0, value.indexOf(','));
    },
  },
  computed: {
    hasWalletPermission() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'dashboard-revenue-display-wallet',
        'SHOW',
      );
    },
    monthWalletTotal() {
      return this.monthWallet.card + this.monthWallet.pix;
    },
    notifyRate() {
      return ((this.notifyAmountTotal * 100) / this.todayTotal).toFixed(1);
    },
    totalOccupancyRate() {
      return (
        (this.totalParkingOccuped * 100) /
        this.totalParkingAvailable
      ).toFixed(0);
    },
    monthTotal() {
      return Object.keys(this.monthReport).reduce((acc, i) => {
        return (acc += Number(this.monthReport[i].totalAmountPaid));
      }, 0);
    },
    todayTotal() {
      const today = moment(new Date()).format('DD-MM-YYYY');
      return this.monthReport[today]
        ? Number(this.monthReport[today].totalAmountPaid)
        : 0;
    },
    totalParkingAvailable() {
      return this.parkingUse.parkStats.reduce(
        (acc, i) => (acc += i.spaceCount),
        0,
      );
    },
    totalParkingOccuped() {
      return this.parkingUse.parkStats.reduce((acc, i) => (acc += i.count), 0);
    },
    percentualNotify() {
      const total = this.todayTotal + this.notifyAmountTotal;
      const perc = (this.notifyAmountTotal * 100) / total;
      return perc.toFixed(0);
    },
    // percentualAged() {
    //   const total = this.todayTotal + this.agedAmountTotal;
    //   const perc = (this.agedCount * 100) / this.todayTotal;
    //   return perc.toFixed(0);
    // },
  },
  mounted() {
    this.loadMonthReport();
    this.loadParkingUse();
    this.loadNotifyCount();
    this.loadMonthWallet();
    // this.loadNotifyRanking()
    this.defineCurrentMonth();
    this.refreshData();
  },
  destroyed() {
    clearInterval(intervalRefresh);
  },
  methods: {
    refreshData() {
      this.lastDateRefresh = moment(new Date()).format('hh:mm:ss');

      const minutes = 5 * 60 * 1000;
      intervalRefresh = setInterval(() => {
        this.lastDateRefresh = moment(new Date()).format('hh:mm:ss');
        this.loadMonthReport();
        this.loadMonthWallet();
        this.loadParkingUse();
        this.loadNotifyCount();
        this.defineCurrentMonth();
        // this.loadNotifyRanking
      }, minutes);
    },
    defineCurrentMonth() {
      const dt = new Date();
      const month = dt.getMonth();
      const year = dt.getFullYear();
      const months = [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ];
      this.currentMonth = `${months[month]}/${year}`;
    },
    async loadMonthReport() {
      const query = {
        currentDate: new Date(),
      };
      const monthReport = await this.$store.dispatch('DASHBOARD/MonthReport', {
        query,
      });
      this.monthReport = monthReport;
    },
    async loadMonthWallet() {
      const query = {
        currentDate: new Date(),
      };
      const monthWallet = await this.$store.dispatch('DASHBOARD/MonthWallet', {
        query,
      });
      this.monthWallet.card = monthWallet.totalCard;
      this.monthWallet.pix = monthWallet.totalPix;
    },
    async loadParkingUse() {
      const firstPeriodStart = moment(new Date())
        .set({
          hour: this.parkingUseFilter.firstPeriodStart,
          minute: 0,
          second: 0,
        })
        .toDate();
      const firstPeriodEnd = moment(new Date())
        .set({
          hour: this.parkingUseFilter.firstPeriodEnd,
          minute: 0,
          second: 0,
        })
        .toDate();
      const secondPeriodStart = moment(new Date())
        .set({
          hour: this.parkingUseFilter.secondPeriodStart,
          minute: 0,
          second: 0,
        })
        .toDate();
      const secondPeriodEnd = moment(new Date()).toDate();

      const parkingUse = await this.$store.dispatch('DASHBOARD/ParkingUse', {
        firstPeriodStart,
        firstPeriodEnd,
        secondPeriodStart,
        secondPeriodEnd,
      });
      this.parkingUse = parkingUse;
    },
    async loadNotifyCount() {
      const { notify, aged } = await this.$store.dispatch(
        'DASHBOARD/NotifyCount',
      );

      this.notifyCount = notify.count;
      this.notifyAmountTotal = notify.amountTotal;

      this.agedCount = aged.count;
      this.exceptions = aged.exceptions;
      this.agedAmountTotal = aged.amountTotal;
    },
    // async loadNotifyRanking() {
    //   const notifyRanking = await this.$store.dispatch('DASHBOARD/NotifyRanking')
    //   this.notifyRanking = notifyRanking ? notifyRanking.notifications: []
    // },
  },
};
</script>
